<template>
    <div class="container-fluid">
        <div class="row content-body  align-items-center">
            <div class="col-12">
                <div class="row align-items-center justify-content-center">

                    <!-- image -->
                    <div class="col-12 col-sm-7 form-group text-center">
                        <img class="img-fluid img-main" src="../assets/images/intro.png">
                    </div>
                    <!-- end image -->


                    <!-- content -->
                    <div class="col-12 col-sm-auto">
                        <div class="row align-items-center justify-content-center">
                            <div class="col-auto col-sm-12">


                                <div class="md-headline form-group">
                                    <div class="main-title txt-white">Retirement Checkup</div>
                                    <div>วางแผน คำนวณเป้าหมายเงินเก็บหลังเกษียณ</div>
                                </div>

                                <div class="form-group sub-title">
                                    <div>เวลาที่ใช้ทำแบบทดสอบ 8 นาที</div>
                                </div>

                                <div class="form-group sub-title">
                                    <div>ข้อมูลกองทุนสำรองเลี้ยงชีพ (Provident fund : PVD) ที่ต้องเตรียม (หากมี)</div>
                                </div>

                                <div class="row justify-content-end align-items-center">
                                    <div class="col-12 form-group">

                                        <ul>

                                            <li>
                                                ยอดเงินใน PVD ที่มีในปัจจุบัน
                                            </li>

                                            <li>
                                                แผนการลงทุนในกองทุนสำรองเลี้ยงชีพ (สัดส่วนของแต่ละสินทรัพย์)
                                                <img class="img-fluid icon-info"
                                                     @click="getInfo('สัดส่วนของแต่ละสินทรัพย์')"
                                                     src="../assets/images/info.png">
                                            </li>

                                            <li>
                                                % เงินที่จ่ายสะสมเองและเงินที่นายจ้างสมทบให้
                                            </li>
                                        </ul>

                                    </div>
                                </div>


                                <router-link to="/basic">
                                    <div class="button-yellow"> เริ่มคำนวณ</div>
                                </router-link>


                            </div>
                        </div>
                    </div>
                    <!-- end content -->

                </div>
            </div>
        </div>

        <dialog-normal :data="dataDialogNormal" :show="showDialogNormal" :dialog="dialog"
                       @close="close"></dialog-normal>
    </div>
</template>

<script>
  import {assetsService} from '../services/assets'
  import DialogNormal from "../components/dialogNormal";


  export default {
    name: 'home',
    components: {DialogNormal},
    data: () => ({
      dialog: {
        header: null,
        desc: null,
      },
      showDialogNormal: false,
      dataDialogNormal: {},
    }),
    methods: {
      getInfo(type) {

        let data = assetsService.getAssetsInfo(type);
        if (!data) return;

        this.showDialogNormal = true;
        this.dialog.message = `<div class="text-center md-display-1 mb-2 txt-gray"> ${data.name} </div>
                                 <div class="md-title mb-3 txt-gray"> ${data.desc}
                                 </div>
                              `
      },
      close() {
        this.showDialogNormal = false;
      },
    }
  }
</script>


<style lang="scss" scoped>
    @import "../assets/css/colors";

    .content-body {
        background-color: $accent;
    }

    .img-main {
        max-height: 300px;
        margin-bottom: 30px;
    }

    .list-group-item {
        background-color: transparent;
        border: none;
        padding: .35rem 1.25rem
    }

    .button-yellow {
        font-size: 1.3rem;
    }

    .main-title {
        font-size: 55px;
        line-height: 1.2;
    }

    @media only screen and (max-width: 578px) {
        .main-title {
            font-size: 45px;
        }
    }
</style>

